// @import Dependencies
import i18n from '@translation/i18n';
import * as Yup from 'yup';
// @import Utils
import { camalize } from '@utils/validations';

export const renderAuthFormLabel = (field, page) => {
  if (page === 'signUp') {
    return i18n.t(`signUp.form.fields.${camalize(field)}.label`);
  }
};
export const renderAuthPlaceholder = (field, page) => {
  if (page === 'signUp') {
    return i18n.t(`${page}.form.fields.${camalize(field)}.placeholder`);
  }
  return i18n.t(`${page}.form.fields.${camalize(field)}.label`);
};

export const passwordValidation = () => {
  return Yup.string()
    .min(8, i18n.t(`signUp.form.fields.password.minLength`))
    .matches(
      /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&+.,_])[A-Za-z\d@$!%*?&+.,_]{8,}$/,
      i18n.t(`signUp.form.fields.password.pattern`)
    )
    .required(i18n.t(`signUp.form.fields.password.required`));
};
